export class EmployeeLocation {
  constructor(
    public readonly id: string,
    public readonly employeeId: string,
    public readonly vehicleId: string | null,
    public readonly lat: number,
    public readonly lon: number,
    public readonly angle: number,
    public readonly timestamp: Date,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {}

  static fromJson(json: any): EmployeeLocation {
    return new EmployeeLocation(
      json["uuid"],
      json["user_sub"],
      json["vehicle_id"] ?? null,
      json["lat"],
      json["lon"],
      json["angle"],
      new Date(json["timestamp"]),
      new Date(json["created_at"]),
      new Date(json["updated_at"]),
    );
  }
}
